function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 4H5v-.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5V4zm0 7H5v13.5a.5.5 0 00.5.5H19v-5h-9v-9zm16.5 9H26v5h.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zM25 5.5v21a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-5.792L9.292 10H3.5a.5.5 0 01-.5-.5v-4a.5.5 0 01.5-.5h21a.5.5 0 01.5.5zm-5 13.794V10h-9.294L20 19.294z"
})));